var FormInputMapper = function () {

    "use strict";

    var self = this;

    this.initialize = function () {
        this.eventDelegation();
        this.activateItemFromInputValue();
    };

    this.eventDelegation = function () {
        $("body").on("change", "[data-input-type=mapper]", function () {
            self.setValueToInput(this);
        });

        $("body").on("click", "[data-input-type=mapper]", function (event) {
            if ($(event.target).is('a')) {
                return;
            }
            self.activateInput(this, '[data-input-group=' + $(this).data('input-group') + ']');
            self.setValueToInput(this);
        });
        $('[data-mapper=relatedinput]').change(function (event) {
            var inputMapped = $(this).parents('[data-input-type=mapper]');

            if (inputMapped.length == 0) {
                inputMapped = $(this).parents('[data-input-type=mapper-no-status]');
            }
            if ($(this).val() == 0) {
                self.activateInput(inputMapped);
            }
            self.setValueToInput(inputMapped);
        });
    };

    this.activateItemFromInputValue = function () {
        $("[data-input-type=mapper]").each(function (index) {
            let input = $('[name=' + $(this).data("input") + ']');
            if (input.val() > 0) {
                $(this).addClass('active-item');
                input.prop('disabled', false);
            } else {
                input.prop('disabled', true);
            }
        });
    };

    this.activateInput = function (input, nonTarget) {
        var parent = $(input).parents();
        if (parent.data('input-group')) {
            if(parent.data('only-one-selectable')){
                if ($(input).hasClass('active-item')) {
                    $(input).removeClass('active-item');
                } else {
                    $(nonTarget).each(function () {
                        var inputName = parent.data('only-one-selectable') + "_" + $(this).data('id');
                        $('[name="' + inputName +'"]').val(0);
                    });
                    $(nonTarget).removeClass('active-item');
                    $(input).addClass('active-item');
                }
            } else {
                $(nonTarget).removeClass('active-item');
                $(input).addClass('active-item');
            }
        } else {
            if (!$(input).hasClass('disabled')) {
                $(input).toggleClass('active-item');
            } else {
                $(input).removeClass('active-item');
            }
        }
    };

    this.setValueToInput = function (elem) {
        let input = $('[name=' + $(elem).data('input') + ']');
        let relatedInput = $(elem).find('[data-mapper=relatedinput]');
        if ($(elem).hasClass('active-item') || $(elem).data('input-type') == 'mapper-no-status') {
            if (relatedInput.length > 0) {
                if (relatedInput.val()){
                    input.val(relatedInput.val());
                } else {
                    let maxOptionValue = $($(elem).find('[data-mapper=relatedinput] option')[$(elem).find('[data-mapper=relatedinput] option').length -1]).val()
                    relatedInput.val(maxOptionValue)
                    input.val(maxOptionValue);
                }
            } else {
                input.val($(elem).data('input-value'));
            }
        } else {
            input.val(0);
            relatedInput.val($(elem).data('input-value'));
        }

        if (input.val() == 0) {
            input.prop('disabled', true);
        } else {
            input.prop('disabled', false);
        }
    };

    this.initialize();
};

export default FormInputMapper;
